import {ClipboardModule} from '@angular/cdk/clipboard';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {RouterModule} from '@angular/router';
import {NbSecurityModule} from '@nebular/security';
import {NbActionsModule, NbAlertModule, NbAutocompleteModule, NbButtonGroupModule, NbButtonModule, NbCardModule, NbCheckboxModule, NbIconModule, NbInputModule, NbRadioModule, NbSelectModule, NbSpinnerModule, NbTooltipModule} from '@nebular/theme';
import {formatPriceNumber, GridGearComponent, SharedModule} from 'compob2b-libs';
import {TableModule} from 'compob2b-table';
import {CodeIconsComponent} from '../product/code-icons/code-icons.component';
import {ProductMarkersComponent} from '../product/product-markers/product-markers.component';
import {BasketHeaderComponent} from './basket-header/basket-header.component';
import {CartComponent} from './cart-component/cart.component';
import {CartRoutingModule} from './cart-routing.module';
import {CartTableAmountComponent} from './cart-table-amount/cart-table-amount.component';
import {CartOrderBlockComponent} from './cart-order-block/cart-order-block.component';
import {CartTableComponent} from './cart-table/cart-table.component';
import {AddProductComponent} from './popup-add-product/add-product.component';
import {PopupOfferComponent} from './popup-offer/popup-offer.component';
import {PromoCodeComponent} from './promo-code/promo-code.component';
import {SpecificationPopupComponent} from './specification-popup/specification-popup.component';
import {DigitOnlyDirective} from '@uiowa/digit-only'
import {ProductPriceComponent} from '../product/product-list/product-price/product-price.component'
import {ProductAvailabilityComponent} from '../product/product-list/product-availability/product-availability.component'
import {ProductWmsComponent} from '../product/product-list/product-wms/product-wms.component'
import {FileUploadModule} from 'ng2-file-upload'
import {AddToCartComponent} from "./add-to-cart/add-to-cart.component";
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import {SearchAutocompleteComponent} from "../search-autocomplete/search-autocomplete.component";
import {TuiIcon} from "@taiga-ui/core";

@NgModule({
  declarations: [
    CartComponent, CartTableComponent, CartOrderBlockComponent, SpecificationPopupComponent, PopupOfferComponent,
    AddProductComponent, CartTableAmountComponent,
    BasketHeaderComponent, PromoCodeComponent],
  exports: [
    BasketHeaderComponent,
    CartTableAmountComponent,
    CartTableComponent,
    PromoCodeComponent
  ],

    imports: [
        CommonModule,
        CartRoutingModule,
        NbCardModule,
        RouterModule,
        FormsModule,
        TableModule,
        ReactiveFormsModule,
        NbSelectModule,
        NbAlertModule,
        NbRadioModule,
        NbInputModule,
        NbCheckboxModule,
        NbAutocompleteModule,
        SharedModule,
        NbActionsModule,
        NbIconModule,
        NbSpinnerModule,
        NbSecurityModule,
        NbButtonModule,
        GridGearComponent,
        ClipboardModule,
        NbTooltipModule,
        NbButtonGroupModule,
        ProductMarkersComponent,
        CodeIconsComponent,
        formatPriceNumber,
        DigitOnlyDirective,
        ProductPriceComponent,
        ProductAvailabilityComponent,
        ProductWmsComponent,
        FileUploadModule,
        AddToCartComponent,
        MatMenu,
        MatMenuTrigger,
        SearchAutocompleteComponent,
        TuiIcon
    ]

})
export class CartModule {
}
